import {store} from '../lib/store'
import {api} from '../lib/api'

export function systemComment(action) {
	if (action == 'approved') {
		return 'Согласовано'
	}
	else if (action == 'created') {
		return 'Заявка создана'
	}
	else if (action == 'withdraw') {
		return 'Решение отозвано'
	}
	else if (action == 'changed') {
		return 'Ведомость изменена'
	}
	else if (action == 'drop') {
		return 'Согласования сброшены'
	}
	else if (action == 'sent_to_approve') {
		return 'Ведомость отправлена на утверждение'
	}
}
export function systemIcon(action) {
	if (action == 'approved'
		|| action == 'sent_to_approve'
	) {
		return {
			name: 'check_circle',
			color: 'green'
		}
	}
	else if (action == 'withdraw') {
		return {
			name: 'undo',
			color: 'white'
		}
	}
	else if (action == 'changed') {
		return {
			name: 'edit',
			color: 'deep-orange'
		}
	}
	else {
		return {
			name: '',
			color: ''
		}
	}
}
